module.exports = __webpack_public_path__ + "img/shopify-logo.75a66f00.png";